import React, { useState } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import isSSR from 'venuescanner-js/services/isSSR';
import { SpaceShape } from 'venuescanner-js/react/shapes';
import { HeartIcon } from 'venuescanner-js/react/components/Objects/Icons/muiIcons/HeartIcon';
const handleShortlistClick = (space, isInShortlist) => {
  return new Promise(resolve => {
    if (!isSSR()) {
      if (window.shortlist) window.shortlist.toggle(space.id, null, resolve);
    }
  });
};

const ShortlistIconButtonContainer = styled('div')({
  top: 3,
});

const ShortlistButton = ({ onClick, isInShortlist, isReducedSpace }) => {
  return (
    <ShortlistIconButtonContainer
      className='space-tile__like'
      id={isReducedSpace ? 'shorlist-srp-heart' : ''}>
      <IconButton aria-label='Add to shortlist' onClick={onClick}>
        <HeartIcon
          fontSize='large'
          color={isInShortlist ? 'secondary' : 'rgb(255, 255, 255)'}
        />
      </IconButton>
    </ShortlistIconButtonContainer>
  );
};

ShortlistButton.propTypes = {
  isInShortlist: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  isReducedSpace: PropTypes.bool,
};

const ShortlistButtonContainer = ({ space, isReducedSpace }) => {
  const [isInShortlist, setIsInShortlist] = useState(false);
  if (!isSSR()) {
    setTimeout(() => {
      setIsInShortlist(
        !isSSR() && window.shortlist ? window.shortlist.isAdded(space) : false,
      );
    });
  }

  return (
    <ShortlistButton
      space={space}
      isInShortlist={isInShortlist}
      isReducedSpace={isReducedSpace}
      onClick={async () => {
        await handleShortlistClick(space, isInShortlist);
        setIsInShortlist(
          !isSSR() && window.shortlist
            ? window.shortlist.isAdded(space)
            : false,
        );
      }}
    />
  );
};

ShortlistButtonContainer.propTypes = {
  space: SpaceShape.isRequired,
  isReducedSpace: PropTypes.bool,
};

export default ShortlistButtonContainer;
